import { useNavigate } from "react-router-dom";

import { AppBar } from "../app/Shell";
import { Button } from "../components/primitives";
import { EmptyState } from "../components/feedback";

/** `W-11` 작업을 찾을 수 없을 때.
 *
 * **작업 셸을 세우지 않는다.** 헤더에 쓸 상품명·썸네일·판 번호가 없으므로 껍데기부터 그릴
 * 수 없다. 상단 헤더만 있는 화면에 빈 상태를 둔다.
 *
 * **왜 없는지는 단정하지 않는다.** 남의 작업인지 지워진 작업인지를 화면이 구분해 말하면
 * 주소만 바꿔 넣어 남의 작업이 있는지 없는지를 알아낼 수 있다(PRD 7.7.2a).
 *
 * 화면 번호 `W-11` 은 코드 안의 표지다. 화면에 그리지 않는다. */
export function JobNotFoundScreen() {
  const navigate = useNavigate();

  return (
    <div className="wrap">
      <div className="shell">
        <AppBar />
        <div className="panel">
          <EmptyState
            art="▤"
            title="이 작업을 찾을 수 없습니다"
            body={
              <>
                지워졌거나, 다른 계정의 작업일 수 있습니다. 링크가 오래된 것이면 <b>내 작업</b>에서
                다시 찾아 주세요.
              </>
            }
            action={<Button label="내 작업" onClick={() => navigate("/jobs")} />}
          />
          {/* ⛔ 발밑의 「여기선 아직 못 합니다. 지운 작업 복구 · 작업 주인에게 접근 요청」 줄을
              걷었다 (2026-10-05 사용자 지시). 아직 없는 기능을 늘어놓는 설계 메모였다. */}
        </div>
      </div>
    </div>
  );
}
